import { contains as u } from "./dom.js";
function d(e) {
  return !!(e.currentTarget && !u(e.currentTarget, e.target));
}
function v(e) {
  return e.target === e.currentTarget;
}
function E(e, r) {
  const n = new MouseEvent("click", r);
  return e.dispatchEvent(n);
}
function l(e, r) {
  const n = r || e.currentTarget, t = e.relatedTarget;
  return !t || !u(n, t);
}
function g(e, r, n) {
  const t = requestAnimationFrame(() => {
    e.removeEventListener(r, i, !0), n();
  }), i = () => {
    cancelAnimationFrame(t), n();
  };
  return e.addEventListener(r, i, {
    once: !0,
    capture: !0
  }), t;
}
function s(e, r, n, t) {
  var o;
  t === void 0 && (t = window);
  try {
    t.document.addEventListener(e, r, n);
  } catch {
  }
  const i = [];
  for (let a = 0; a < ((o = t.frames) == null ? void 0 : o.length); a += 1) {
    const c = t.frames[a];
    c && i.push(s(e, r, n, c));
  }
  return () => {
    try {
      t.document.removeEventListener(e, r, n);
    } catch {
    }
    i.forEach((a) => a());
  };
}
export {
  s as addGlobalEventListener,
  E as fireClickEvent,
  l as isFocusEventOutside,
  d as isPortalEvent,
  v as isSelfTarget,
  g as queueBeforeEvent
};
//# sourceMappingURL=events.js.map
